import EntityImageVM, { EntityImageVMConfig } from 'components/entityImage/entityImage';
import { wccModules } from 'enums/wccModules';
import topicBadgesFactory from 'factories/topicBadges';
import { inject, injectable } from 'inversify';
import { SubscribableOrNullableValue } from 'knockout';
import { SimpleTopic } from 'models/simpleTopic';

interface TopicImageVMConfig extends EntityImageVMConfig {
    topic: SubscribableOrNullableValue<SimpleTopic>
}

@injectable()
export default class TopicImageVM extends EntityImageVM<SimpleTopic> {
    constructor(
        @inject(wccModules.componentConfig) config: TopicImageVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super({
            entity: config.topic,

            ...config
        }, info);
    }

    protected getBadge(topic: SimpleTopic) {
        return topicBadgesFactory.buildBadge({
            topicType: topic.type(),
            topicContentType: topic.contentType(),
            videoPresentationType: topic.videoPresentationType()
        });
    }
}